const __WEBPACK_NAMESPACE_OBJECT__ = require("@patsnap-ui/icon/assets/solid/ZoomOut.svg");